import React from "react";

class ProductPage extends React.Component {
  render() {
    let contents = "";

    if (this.props.language === "EN") {
      contents = <h2>All Brands, Parts and Systems</h2>;
    } else {
      contents = <h2>Todas las Marcas, Partes, y Sistemas</h2>;
    }

    return (
      <div className="ProductPage">
        <div>
          {contents}
          <div className="image-container">
            <img src="./img/img1.png" alt="" />
            <img src="./img/img4.png" alt="" />
            <img src="./img/img5.jpg" alt="" />
            <img src="./img/img9.png" alt="" />
            <img src="./img/img10.jpg" alt="" />
            <img src="./img/img11.png" alt="" />
            <img src="./img/img12.jpg" alt="" />
            <img src="./img/img13.jpg" alt="" />
            <img src="./img/img14.jpg" alt="" />
            <img src="./img/img15.jpg" alt="" />
            <img src="./img/img16.jpg" alt="" />
            <img src="./img/img17.jpg" alt="" />
            <img src="./img/img18.jpg" alt="" />
            <img src="./img/img19.jpg" alt="" />
            <img src="./img/img20.jpg" alt="" />
            <img src="./img/img21.jpg" alt="" />
            <img src="./img/img22.jpg" alt="" />
            <img src="./img/img23.jpg" alt="" />
            <img src="./img/img24.jpg" alt="" />
          </div>
        </div>
      </div>
    );
  }
}

export default ProductPage;



// WEBPACK FOOTER //
// ./src/ProductPage.js